import { render } from "./DetalharAulaAvulsa.vue?vue&type=template&id=24604358&scoped=true"
import script from "./DetalharAulaAvulsa.vue?vue&type=script&lang=js"
export * from "./DetalharAulaAvulsa.vue?vue&type=script&lang=js"

import "./DetalharAulaAvulsa.vue?vue&type=style&index=0&id=24604358&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24604358"]])

export default __exports__